import { ButtonContainer, Icon } from './GoogleButton.styles';

import { ROUTES } from 'features/routes';
import { googleSignin } from 'services/auth';
import { setIsNewGoogleAccount } from 'store/slices/GoogleSlice';
import { useAppDispatch } from 'store/hooks';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const GoogleButton = () => {
	const { t } = useTranslation();
	const { push } = useHistory();
	const dispatch = useAppDispatch();

	const myCallback = (results: any, error: any) => {
		if (results) {
			push(ROUTES.HOME_PATH);
		} else if (error) {
			dispatch(setIsNewGoogleAccount());
			push(ROUTES.CREATE_ACCOUNT_PATH);
		}
	};

	return (
		<ButtonContainer onClick={() => dispatch(googleSignin(myCallback, push))} type="button">
			<Icon iconName="google" />
			{t('login-google')}
		</ButtonContainer>
	);
};
